import { useTranslation } from "react-i18next";
import { useState, useEffect, useMemo } from "react";
import { M_Select } from "../../../../M_Components";
import { genericEntityService, getReferenceColumnDropdownItems } from "src/services/genericEntityService";

export const ReferenceColumnFieldItemForm = ({ field, entityId, changeValueCallback, itemForm, isDisabled }) => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;
    const defaultValue = useMemo(() => field.AllowMultiple ? [] : "", [field.AllowMultiple])
    const [options, setOptions] = useState([]);
    const [selectedItems, setSelectedItems] = useState(defaultValue);
    const valueKey = field.AllowMultiple ? 'Id' : 'value';
    
    const label = useMemo(() => {
        return field?.Captions[currentLanguage]?.length > 0 
                    ? field?.Captions[currentLanguage] 
                    : field?.Code
    }, [field, currentLanguage])

    useEffect(() => {
        if (!entityId || !field.FieldId){
            return;
        }

        genericEntityService.getReferenceColumnDropdownItems(entityId, field.FieldId)
                .then(response => {
                    const items = response.data?.map(e => {
                        return {
                            label: e.Label,
                            Id: e.Id,
                            value: e.Id
                        }
                    })
                    setOptions(items);
                });


    }, [entityId, field]);

    const handleInputChange = (value) => {
        const normalized = Array.isArray(value)
            ? value
            : value
                ? [value]
                : [];

        const parsedValues = normalized.map(v => v[valueKey]);

        changeValueCallback({
            ...itemForm,
            form: {
                ...itemForm.form,
                [field.Code]: JSON.stringify(parsedValues)
            }
        });
    }

    useEffect(() => {
        const rawValue = itemForm.form[field.Code];
      
        if (!rawValue) {
            setSelectedItems(defaultValue);
            return;
        }

        let parsedIds = [];
        try {
            parsedIds = JSON.parse(rawValue);
        } catch {
            parsedIds = [];
        }
        
        const matchedOptions = parsedIds
            .map(id => options.find(o => o[valueKey].toUpperCase() === id.toUpperCase()))
            .filter(Boolean);

        if (matchedOptions.length === 0){
            setSelectedItems(defaultValue)
            return;
        }

        if (field.AllowMultiple) {
            setSelectedItems(
                isDisabled
                    ? matchedOptions.map(o => o?.value)
                    : matchedOptions
            );
        } else {
            setSelectedItems(
                isDisabled ? matchedOptions[0]?.value : matchedOptions[0]
            );
        }
    }, [itemForm.form, options, isDisabled, field.Code, valueKey]);

    return (
        <div className="dropdown">
            <M_Select
                autocomplete={!isDisabled}
                label={label}
                value={selectedItems}
                noNone={!field.IsMandatory}
                multiple={field.AllowMultiple}
                options={options}
                disabled={isDisabled}
                onChangeValue={handleInputChange}
            />
        </div>
    )
}